<template>
  <qtm-chip color="light-grey" text-color="mid-dark-grey" class="text-no-wrap pa-1">
    <v-icon icon="mdi-power-sleep" />
    Out Of Office
  </qtm-chip>
</template>

<script setup lang="ts">
</script>
